import _ from "lodash";
/**--external-- */
import React, { useRef, useImperativeHandle } from "react";
import classNames from "classnames";
import propTypes from "prop-types";

/**--internal-- */
import I18nHOC from "UIComponents/I18nHOC";
import Timezone from "UIComponents/Timezone";
import OperationalDays from "UIComponents/OperationalDays";
import AcademicYearsSetup from "../../../AcademicYearsSetup";

/**--relative-- */
import classes from "./Step2.scss";

const Step2 = props => {
  const {
    t,
    academicYears,
    operationalDays,
    updateOrganizationInformation,
    timezone,
    customRef,
  } = props;
  const headerClasses = classNames("heading-3", classes.header);
  const subHeaderClasses = classNames("heading-5", classes.subHeader);

  const updateOperationalDays = value => {
    updateOrganizationInformation({
      key: "operationalDays",
      value,
    });
  };

  const updateTimezone = timezone => {
    updateOrganizationInformation({ key: "timezone", value: timezone });
  };

  const timezoneRef = useRef();

  useImperativeHandle(customRef, () => {
    return {
      isValid: () => {
        const totalErrors = _.reduce(
          [timezoneRef.current],
          (result, node) => {
            return result + (node?.isValid?.() ?? 0);
          },
          0
        );

        return totalErrors === 0;
      },
    };
  });

  return (
    <div className={classes.container}>
      <h3 className={headerClasses}>
        {t("onBoarding:configure_academic_year")}
      </h3>
      <div>
        <AcademicYearsSetup
          t={t}
          academicYears={academicYears}
          updateOrgObject={({ academicYears }) =>
            updateOrganizationInformation({
              key: "academicYears",
              value: academicYears,
            })
          }
        />
      </div>
      <div className={classes.footer}>
        <h5 className={subHeaderClasses}>
          {t("onBoarding:define_time_zone_operational_days")}
        </h5>
        <div className={classes.timezoneContainer}>
          <Timezone
            value={timezone}
            updateInputField={updateTimezone}
            menuPlacement="top"
            isRequired
            timezoneRef={timezoneRef}
          />
        </div>
        <OperationalDays
          operationalDays={operationalDays}
          updateOperationalDays={updateOperationalDays}
        />
      </div>
    </div>
  );
};

Step2.propTypes = {
  t: propTypes.func,
  academicYears: propTypes.arrayOf(propTypes.object),
  operationalDays: propTypes.array,
  updateOrganizationInformation: propTypes.func,
  timezone: propTypes.string,
};

export default I18nHOC({ resource: ["onBoarding", "common"] })(Step2);
